// Dourado vocabulary expansion — FAMILY theme (net-new cards).
//
// Extends the `family` blocks in ./vocabulary.js without reusing any headword
// already defined there. Seed upserts on `portuguese`, so every value is unique.
//   [ portuguese, english, emoji, part_of_speech, gender, example_pt, example_en ]

export const VOCAB_FAMILY = [
  {
    theme: "family", tier: "A1", rows: [
      ["os pais", "parents", "👪", "noun", "m", "Os meus pais vivem em Oslo.", "My parents live in Oslo."],
      ["os filhos", "children", "👧", "noun", "m", "Têm três filhos.", "They have three children."],
      ["o marido", "husband", "🤵", "noun", "m", "O marido dela cozinha muito bem.", "Her husband cooks very well."],
      ["o companheiro", "partner / couple", "💑", "noun", "m", "Vive com o companheiro.", "She lives with her partner."],
      ["o namorado", "boyfriend", "❤️", "noun", "m", "O meu namorado é de Sevilha.", "My boyfriend is from Seville."],
      ["a namorada", "girlfriend", "💕", "noun", "f", "A namorada dele fala francês.", "His girlfriend speaks French."],
      ["o gémeo", "twin", "👬", "noun", "m", "O gémeo dele vive em Madrid.", "His twin lives in Madrid."],
      ["casar-se", "to get married", "💒", "verb", "", "Casam-se em junho.", "They're getting married in June."],
      ["o casamento", "wedding", "💍", "noun", "m", "O casamento é em setembro.", "The wedding is in September."],
      ["o filho único", "only child", "🧒", "phrase", "", "Sou filho único.", "I'm an only child."],
    ],
  },
  {
    theme: "family", tier: "A2", rows: [
      ["a sobrinha", "niece", "👧", "noun", "f", "A minha sobrinha faz dez anos.", "My niece turns ten."],
      ["a neta", "granddaughter", "👧", "noun", "f", "A neta dele nasceu em março.", "His granddaughter was born in March."],
      ["a prima", "cousin (f)", "👩", "noun", "f", "A minha prima vive no Chile.", "My cousin lives in Chile."],
      ["a sogra", "mother-in-law", "👵", "noun", "f", "A minha sogra é muito amável.", "My mother-in-law is very kind."],
      ["a cunhada", "sister-in-law", "👩", "noun", "f", "A cunhada dele é enfermeira.", "His sister-in-law is a nurse."],
      ["a nora", "daughter-in-law", "👰", "noun", "f", "A nora dela trabalha no banco.", "Her daughter-in-law works at the bank."],
      ["o padrinho", "godfather", "🎩", "noun", "m", "O meu padrinho vive perto.", "My godfather lives nearby."],
      ["divorciado", "divorced", "💔", "adjective", "", "Os meus pais estão divorciados.", "My parents are divorced."],
      ["o padrasto", "stepfather", "👨", "noun", "m", "O padrasto dela é muito paciente.", "Her stepfather is very patient."],
      ["a madrasta", "stepmother", "👩", "noun", "f", "A minha madrasta cozinha muito bem.", "My stepmother cooks brilliantly."],
    ],
  },
  {
    theme: "family", tier: "B1", rows: [
      ["o lar", "home / household", "🏡", "noun", "m", "Tenho saudades do meu lar.", "I miss my home."],
      ["o laço", "tie / bond", "🔗", "noun", "m", "Há um laço forte entre eles.", "There's a strong tie between them."],
      ["o apoio", "support", "🤝", "noun", "m", "Conto com o apoio da minha família.", "I count on my family's support."],
      ["a separação", "separation", "💔", "noun", "f", "A separação foi difícil.", "The separation was hard."],
      ["acolher", "to take in", "🫂", "verb", "", "Acolheram uma criança refugiada.", "They took in a refugee child."],
      ["o seio familiar", "the family fold", "👪", "phrase", "", "Cresceu no seio de uma família humilde.", "He grew up in a humble family."],
      ["os achegados", "close relations", "👥", "noun", "m", "Só vieram os achegados.", "Only close relations came."],
      ["consanguíneo", "blood-related", "🧬", "adjective", "", "Não são parentes consanguíneos.", "They are not blood relatives."],
      ["a descendência", "offspring", "🌳", "noun", "f", "Não tiveram descendência.", "They had no offspring."],
      ["velar por", "to watch over", "🕯️", "phrase", "", "Os pais velam pelos filhos.", "Parents watch over their children."],
    ],
  },
];
